import React, { useState } from 'react'
import ShippingInfo from './ShippingInfo';
import Confirmation from './Confirmation';
import "./Checkout.css";

const Checkout = ({cart, emptyCart}) => {

    const [page , setPage] = useState(0);

    const checkoutPage = (data) => {
        setPage(data);
    }

  return (
    <div className='collection'>
        {page===0 && <ShippingInfo emptyCart={emptyCart} checkoutPage={checkoutPage} cart={cart}/>}
        {page===1 && <Confirmation />}
    </div>
  )
}

export default Checkout